module.exports = __webpack_public_path__ + "static/media/flat-lay-desk-with-coffee-keyboard.499b688c.jpg";